
import React , {createContext, useContext, useState , ReactNode, useEffect} from 'react';
import PageTitle from '../../components/PageTitle';
import api from "../../api/axiosClient"
import genStyles from '../../styles/General.module.css'
import { Button, Checkbox, Tabs} from '@mantine/core';
import {ModelsRowType} from '../../types/models';
import ModelsList from './ModelsList';
import {useDisclosure } from '@mantine/hooks';
import ModelsPopUp from './ModelsPopUp';

const ModelsPage = () => {
    const [activeTab, setActiveTab] = useState<string | null>('Color');
    const [recyclingModels, setRecyclingModels] = useState<ModelsRowType[]>([]);
    const [reuseModels, setReuseModels] = useState<ModelsRowType[]>([]);
    const [colorModels, setColorModels] = useState<ModelsRowType[]>([]);
    const [data, setData] = useState<ModelsRowType[] | null>(null);
    const [opened, { open, close }] = useDisclosure(false);


    const endpoints: Record<string, string> = {
        Color: 'color-models',
        Recycling: 'recycling-models',
        Reuse: 'reuse-models',
    };

    const deleteModel = async (id: number) => {
        const endpoint = endpoints[activeTab ? activeTab : 'Color'];
        await api.delete(`/sorter/model/${endpoint}/${id}`);
        const updatedData = data?.filter((item) => item.id !== id) || [];
        setData(updatedData);
        if (activeTab === 'Color') {
            setColorModels(updatedData);
        } else if (activeTab === 'Recycling') {
            setRecyclingModels(updatedData);
        } else if (activeTab === 'Reuse') {
            setReuseModels(updatedData);
        }
    }

     const onClickAdd = async (newModel: ModelsRowType) => {
        console.log("Adding new model", newModel);
        const endpoint = endpoints[activeTab ? activeTab : 'Color'];
        const response = await api.post(`/sorter/model/${endpoint}`, newModel);
        const updatedData = [...(data || []), response.data];
        setData(updatedData);
        if (activeTab === 'Color') {
            setColorModels(updatedData);
        } else if (activeTab === 'Recycling') {
            setRecyclingModels(updatedData);
        } else if (activeTab === 'Reuse') {
            setReuseModels(updatedData);
            }
        
        close();
    }


    useEffect(() => {
        const fetchModels = async () => {
        try {
            const response = await api.get<ModelsRowType[]>(`/sorter/model/recycling-models`);
            setRecyclingModels(response.data);
            const response2 = await api.get<ModelsRowType[]>(`/sorter/model/reuse-models`);
            setReuseModels(response2.data);
            const response3 = await api.get<ModelsRowType[]>(`/sorter/model/color-models`);
            setColorModels(response3.data);
        } catch (error) {
            console.error("Error fetching models:", error);
            setRecyclingModels([])
            setReuseModels([])
            setColorModels([])
        }};
        fetchModels();
    }, []);

    useEffect(() => {
        switch (activeTab) {
            case 'Color':
            setData(colorModels);
            break;
            case 'Recycling':
            setData(recyclingModels);
            break;
            case 'Reuse':
            setData(reuseModels);
            break;
            default:
            break;
        }
    }, [activeTab, recyclingModels, reuseModels, colorModels]);


    return (
        <div>
            <ModelsPopUp opened={opened} close={close} title={`Add ${activeTab} Model`} onSave={onClickAdd} ></ModelsPopUp>

            <PageTitle title="Models"></PageTitle>
             <div className={genStyles.PageMain}>   
                <Tabs  color="#474973" radius="md" value={activeTab} onChange={setActiveTab}>
                <div className={genStyles.TabsHeaderRow}> 
                      <Tabs.List>
                          <Tabs.Tab className={genStyles.Tab} value="Color">Colors</Tabs.Tab>
                          <Tabs.Tab className={genStyles.Tab} value="Recycling">Recycling</Tabs.Tab>
                          <Tabs.Tab className={genStyles.Tab} value="Reuse">Reuse</Tabs.Tab>
                      </Tabs.List>
                </div>
                      <Tabs.Panel value="Color">
                          <ModelsList data={data} activeTab={activeTab} deleteModel={deleteModel}></ModelsList>
                      </Tabs.Panel>  
                      <Tabs.Panel value="Recycling">
                          <ModelsList data={data} activeTab={activeTab} deleteModel={deleteModel}></ModelsList>
                      </Tabs.Panel>
                      <Tabs.Panel value="Reuse">
                          <ModelsList data={data} activeTab={activeTab} deleteModel={deleteModel}></ModelsList>
                      </Tabs.Panel>
              </Tabs>   

              <div className={genStyles.AddButtonWrapper}> 
                 <Button className ={genStyles.AddButton}  onClick={open} variant="filled" color="#62929E" radius="xl">Add</Button>
            </div> 

             </div>
        </div>
);
};

export default ModelsPage;